import React from "react";
import { Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useController } from "react-hook-form";

import { allowOnlyNumbers } from "@utilities";

export const InputFormField = ({
  title,
  error,
  size,
  suffix,
  isLoading,
  control,
  name,
  className = "",
  defaultValue,
  onBlur,
  ...rest
}) => {
  const { field, fieldState } = useController({
    control,
    name,
    ...(defaultValue && { defaultValue })
  });

  const phoneNumberKeyDown = e => {
    if (rest.type !== "tel") return;
    return allowOnlyNumbers(e);
  };

  return (
    <div className="hook-form-input">
      <div
        className={`form-field-wrapper row  ${className}`}
      >
        {title && (
            <div className="form-field-title col-12">
              {title}
            </div>
        )}
        <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
          <Input
            {...rest}
            {...field}
            autoComplete="off"
            placeholder={title}
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck="off"
            size={size}
            onKeyDown={phoneNumberKeyDown}
            className="hide-placeholder"
            suffix={isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : suffix}
          />
          {fieldState?.error?.message && (
            <div className="form-field-error">
              {fieldState.error.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
